import './setup'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/fragment'
import './plugins/element'
import './filters'
import './components/global'
import router from './router'
import store from './store'
import '@/assets/styles'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
